import React, { useState, useEffect } from "react";
import axios from "axios";
import {
    Card,
    Button,
    Input,
    DatePicker,
    List,
    Typography,
    Space,
    message,
    Spin,
} from "antd";
import moment from "moment";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import botApiUrl from "../../botApiUrl";
import axiosInstance from "../../axiosInterceptor";

const { Title } = Typography;
const { TextArea } = Input;

function CalendarDashboard() {
    const accessToken = window.localStorage.getItem("accessToken");
    const [accessTokenGoogle, setAccessTokenGoogle] = useState(window.localStorage.getItem("tokenGoogle") ? window.localStorage.getItem("tokenGoogle") : '');

    const [events, setEvents] = useState([]);
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        summary: "",
        description: "",
        start: null,
        end: null
    });
    const [status, setStatus] = useState('Desconectado');


    const getValidToken = async () => {
        const token = localStorage.getItem("tokenGoogle");
        const expiresAt = parseInt(localStorage.getItem("tokenGoogleExpiresAt"), 10);

        if (!token || !expiresAt || Date.now() >= expiresAt) {

            const options = {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + accessToken,
                },
            };
            try {
                const res = await axiosInstance.post("https://techfood-api.herokuapp.com/auth/google/refresh-token", { 'tokenGoogle': token }, options);
                const newToken = res.data.access_token;
                const newExpiresAt = Date.now() + res.data.expires_in * 1000;

                localStorage.setItem("tokenGoogle", newToken);
                localStorage.setItem("tokenGoogleExpiresAt", newExpiresAt);
                setAccessTokenGoogle(newToken);
                message.success("Token renovado com sucesso!");
                setStatus('Ativo');
            } catch (err) {
                if (err.response.status == 403) {
                    console.log("Erro ao renovar token:", err);
                    message.error(err.response.data.message, 2);
                    setStatus('Desconectado');
                }
            }
        } else {
            setStatus('Ativo');
            setAccessTokenGoogle(token);
        }
    };

    const fetchEvents = async () => {
        if (!accessToken || status == 'Desconectado') return;

        setLoading(true);
        try {
            const res = await axios.get(
                "https://www.googleapis.com/calendar/v3/calendars/primary/events",
                {
                    headers: {
                        Authorization: `Bearer ${accessTokenGoogle}`
                    },
                    params: {
                        timeMin: new Date().toISOString(),
                        singleEvents: true,
                        orderBy: "startTime"
                    }
                }
            );
            setEvents(res.data.items);
            setStatus('Ativo');
        } catch (error) {
            console.error("Erro ao buscar eventos:", error);
            message.error("Erro ao buscar eventos.");
            setStatus('Desconectado');
        }
        setLoading(false);
    };

    const createEvent = async () => {
        if (!form.summary || !form.start || !form.end) {
            message.warning("Preencha todos os campos obrigatórios.");
            return;
        }

        try {
            await axios.post(
                "https://www.googleapis.com/calendar/v3/calendars/primary/events",
                {
                    summary: form.summary,
                    description: form.description,
                    start: {
                        dateTime: form.start.toISOString(),
                        timeZone: "America/Sao_Paulo"
                    },
                    end: {
                        dateTime: form.end.toISOString(),
                        timeZone: "America/Sao_Paulo"
                    }
                },
                {
                    headers: {
                        Authorization: `Bearer ${accessTokenGoogle}`,
                        "Content-Type": "application/json"
                    }
                }
            );
            message.success("Evento criado com sucesso!");
            fetchEvents();
            setForm({ summary: "", description: "", start: null, end: null });
        } catch (error) {
            console.error("Erro ao criar evento:", error);
            message.error("Erro ao criar evento.");
        }
    };

    const deleteEvent = async (eventId) => {
        try {
            await axios.delete(
                `https://www.googleapis.com/calendar/v3/calendars/primary/events/${eventId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accessTokenGoogle}`
                    }
                }
            );
            message.success("Evento excluído.");
            fetchEvents();
        } catch (error) {
            console.error("Erro ao excluir evento:", error);
            message.error("Erro ao excluir evento.");
        }
    };

    useEffect(() => {
        getValidToken();
        console.log('getValidToken');
    }, []);

    useEffect(() => {
        if (accessToken) {
            fetchEvents();
            console.log(fetchEvents());
        }
    }, [accessToken]);
    const handleGoogleLogin = () => {
        const clientId = "1076987333684-35m7upsk194o0usm08sm2q0o5nafhmak.apps.googleusercontent.com"; // Seu ID do cliente real
        //const redirectUri = "http://localhost:3000/oauth"; // Tem que bater com o que está na tela do Google Cloud

        const redirectUri = "https://app.techsbot.com.br/oauth";

        const scope = "https://www.googleapis.com/auth/calendar";
        const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&scope=${scope}&access_type=offline&prompt=consent`;

        window.location.href = authUrl;
    };

    const handleGoogleLogout = async () => {
        const token = localStorage.getItem("tokenGoogle");

        if (!token) {
            console.error("Token não encontrado.");
            return;
        }

        try {
            // Chama o backend para revogar o token no Google
            const response = await fetch("https://techfood-api.herokuapp.com/auth/google/revoke-token", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${accessToken}`
                },
                body: JSON.stringify({ tokenGoogle: token })
            });

            if (response.ok) {
                console.log("Token revogado com sucesso no Google e backend.");

                // Limpa o localStorage
                localStorage.removeItem("tokenGoogle");
                localStorage.removeItem("refresh_token");
                localStorage.removeItem("tokenGoogleExpiresAt");
                setStatus('Desconectado');
                message.success("Deslogado com sucesso.");

            } else {
                if (response.status == 404) {
                    localStorage.removeItem("tokenGoogle");
                    localStorage.removeItem("refresh_token");
                    localStorage.removeItem("tokenGoogleExpiresAt");
                    setStatus('Desconectado');
                    message.success("Deslogado com sucesso.");
                }
                const erro = await response.json();
                console.error("Erro ao revogar token:", erro);
            }
        } catch (err) {
            console.error("Erro na requisição de revogação:", err);
        }
    };



    return (
        <div style={{ padding: "40px", maxWidth: 800, margin: "auto" }}>
            <Card title="Google Calendar Dashboard" bordered={false} style={{ marginBottom: 24 }}>
                <Space direction="vertical" style={{ width: "100%" }}>

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            padding: "10px"
                        }}
                    >
                        <button
                            onClick={handleGoogleLogin}
                            style={{
                                backgroundColor: "#000",
                                color: "#fff",
                                border: "none",
                                padding: "7px 15px",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                fontSize: "12px"
                            }}
                        >
                            Conectar
                        </button>

                        <button
                            onClick={handleGoogleLogout}
                            style={{
                                backgroundColor: "#000",
                                color: "#fff",
                                border: "none",
                                padding: "7px 15px",
                                borderRadius: "5px",
                                cursor: "pointer",
                                fontWeight: "bold",
                                fontSize: "12px"
                            }}
                        >
                            Deslogar
                        </button>


                        <Title level={4} style={{ margin: 0, textAlign: "center" }}>
                            Criar Evento
                        </Title>


                        <Title
                            level={4}
                            style={{
                                margin: 0,
                                color: status === "Ativo" ? "green" : "red"
                            }}
                        >
                            {status}
                        </Title>
                    </div>
                    <Input
                        placeholder="Título do Evento"
                        value={form.summary}
                        onChange={(e) => setForm({ ...form, summary: e.target.value })}
                    />
                    <TextArea
                        placeholder="Descrição"
                        value={form.description}
                        onChange={(e) => setForm({ ...form, description: e.target.value })}
                        rows={3}
                    />
                    <DatePicker
                        showTime
                        placeholder="Início"
                        value={form.start}
                        onChange={(value) => setForm({ ...form, start: value })}
                        style={{ width: "100%" }}
                    />
                    <DatePicker
                        showTime
                        placeholder="Fim"
                        value={form.end}
                        onChange={(value) => setForm({ ...form, end: value })}
                        style={{ width: "100%" }}
                    />
                    <Button
                        type="primary"
                        style={{ backgroundColor: '#000', borderColor: '#000' }}
                        onClick={createEvent}
                    >
                        Criar Evento
                    </Button>
                </Space>
            </Card>

            <Card title="Próximos Eventos">
                {loading ? (
                    <Spin />
                ) : (
                    <List
                        itemLayout="horizontal"
                        dataSource={events}
                        renderItem={(item) => (
                            <List.Item
                                actions={[
                                    <Button
                                        type="link"
                                        danger
                                        icon={<FontAwesomeIcon icon={faTrash} />}
                                        onClick={() => deleteEvent(item.id)}
                                    />

                                ]}
                            >
                                <List.Item.Meta
                                    title={item.summary || "(sem título)"}
                                    description={
                                        <>
                                            <div>
                                                <strong>Início:</strong>{" "}
                                                {item.start?.dateTime
                                                    ? moment(item.start.dateTime).format("DD/MM/YYYY HH:mm")
                                                    : item.start?.date}
                                            </div>
                                            {item.description && (
                                                <div>
                                                    <strong>Descrição:</strong> {item.description}
                                                </div>
                                            )}
                                        </>
                                    }
                                />
                            </List.Item>
                        )}
                    />
                )}
            </Card>
        </div>
    );
}

export default CalendarDashboard;
